'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const Sdot4pxIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={8} cy={8} r={2} fill="currentColor" /></svg>);